import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICES } from "@/lib/content";

export const ServiceChips = ({ value, onChange, prefix }) => {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${prefix}-service-chips`}>
      {SERVICES.map((s) => {
        const on = value.includes(s.id);
        return (
          <motion.button
            type="button"
            key={s.id}
            whileTap={{ scale: 0.95 }}
            onClick={() => toggle(s.id)}
            data-testid={`${prefix}-chip-${s.id}`}
            aria-pressed={on}
            className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors duration-300 ${on ? "border-amber-300 bg-amber-400 font-semibold text-[#0B0F17]" : "border-white/15 bg-white/5 text-slate-200 hover:border-amber-300/60 hover:text-white"}`}
          >
            {on && <Check className="h-3.5 w-3.5" />}
            {s.title}
          </motion.button>
        );
      })}
    </div>
  );
};

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-2 block font-mono-x text-[11px] uppercase tracking-[0.2em] text-slate-400">{label}</span>
    {children}
  </label>
);

export const inputCls = "h-12 w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 text-white placeholder:text-slate-500 outline-none transition-colors focus:border-amber-300";
